import { Injectable } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';

import { AccountingApiService } from 'v2/modules/shared/services/api/accounting-api.service';
import { ExportApiService } from 'v2/modules/shared/services/api/export-api.service';
import { asLumResponseError } from 'v2/shared/api/lum-response-error';
import { LumSnackBar } from 'v2/shared/lum-snack-bar/lum-snack-bar.service';

@Injectable({
  providedIn: 'root',
})
export class AccountingDashboardActionsHelperService {
  constructor(
    private _accountingApi :AccountingApiService,
    private _exportHelper :ExportApiService,
    private _snackBar :LumSnackBar,
  ) {}

  exportJournal(params :{ fromDate :string; endDate :string }) {
    return this._accountingApi.generateJournalWithDateRange(params).pipe(
      tap((response) => {
        if (response !== null && response instanceof Blob) {
          this._exportHelper.saveBlobAsFile(
            response,
            `Accounting ${params.endDate}`,
            'csv',
          );

          this._snackBar.openSuccess('Successfully generated CSV file.', 'Success');
        } else {
          this._snackBar.openWarning('No data found within the date range.');
        }
      }),
      catchError((error) => {
        this._snackBar.openError(error.error, 'Fail');

        return throwError(() =>
          asLumResponseError(error, 'Failed to generate journal', {
            suppressConsoleError: true,
          }),
        );
      }),
    );
  }
}
